export const setBodyOverflow = (isHidden: boolean) =>
    isHidden
        ? document.body.classList.add('hidden-overflow')
        : document.body.classList.remove('hidden-overflow');
